export default __webpack_public_path__ + "static/media/LFS_ACT1.3fc55bf5.png";